module.exports = __webpack_public_path__ + "static/kilian-poulin-31c5f437f1e1985ea44f07fd2b2caf98.jpg";